import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../../contexts/layout.context';
import { useDispatch } from 'react-redux';
import actions from '../../../store/actions';

import Head from '../../../components/Head/Head';
import PasswordForm from '../../../components/Profile/Edit/PasswordForm/PasswordForm';

const EditPassword = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна паролю' goBack={goBack} />
      <div className="profile__content">
        <PasswordForm />
      </div>
    </div>
  );
};

export default EditPassword;